import { checkMultiregionalPhone, checkEmail, checkName, checkNotEmpty } from '~h/validators';

export const courseRegFreeInputs = [
  {
    name: 'lastName',
    label: 'Фамилия',
    type: 'text',
    error: false,
    required: true,
    validator: checkName,
  },
  {
    name: 'name',
    label: 'Имя',
    type: 'text',
    error: false,
    required: true,
    validator: checkName,
  },
  {
    name: 'patronymic',
    label: 'Отчество',
    type: 'text',
    error: false,
    required: true,
    validator: checkName,
  },
  {
    name: 'phone',
    label: 'Телефон',
    type: 'phone',
    error: false,
    required: true,
    validator: checkMultiregionalPhone,
  },
  {
    name: 'email',
    label: 'Эл. почта',
    type: 'text',
    error: false,
    required: true,
    validator: checkEmail,
  },
  {
    name: 'company',
    label: 'Название организации',
    type: 'company',
    error: false,
    required: true,
    validator: checkNotEmpty,
  },
  {
    name: 'companyPosition',
    label: 'Должность',
    type: 'text',
    error: false,
    required: true,
    validator: checkName,
  },
];
